(() => {
  'use strict';

  const configElement = document.getElementById('latrand-ai-search-localisation-config');
  if (!configElement || configElement.dataset.localisationVersion === '3') return;
  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch {
    return;
  }
  if (!config.strings || !config.root) return;
  configElement.dataset.initialised = 'true';
  configElement.dataset.localisationVersion = '3';
  const supported = ['bg', 'en', 'de', 'fr', 'it', 'es'];
  const language = String(config.locale || 'bg').toLowerCase().split('-')[0];
  const locale = supported.includes(language) ? language : 'bg';
  const copy = config.strings;
  const normalise = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const source = {
    products: ['Продукти', 'Products', 'Produkte', 'Produits', 'Prodotti', 'Productos'],
    pages: ['Страници', 'Pages', 'Seiten', 'Pagine', 'Páginas'],
    show_more: ['Покажи още', 'Show more', 'Mehr anzeigen', 'Afficher plus', 'Mostra altro', 'Mostrar más'],
    see_all: ['Вижте всички резултати', 'See all results', 'Alle Ergebnisse anzeigen', 'Voir tous les résultats', 'Vedi tutti i risultati', 'Ver todos los resultados'],
    no_results: ['Няма намерени резултати. Опитайте с модел или артикулен номер, или задайте въпрос.'],
    cart_add: ['Добави в количката', 'Add to cart'],
    cart_added: ['Добавено в количката', 'Added to cart'],
    cart_out_of_stock: ['Изчерпано', 'Изкупено', 'Out of stock'],
    cart_learn_more: ['Научете повече', 'Learn more']
  };
  const known = (key, value) => {
    const normalised = normalise(value);
    return normalised === normalise(copy[key]) || (source[key] || []).some((item) => normalise(item) === normalised);
  };
  const setAttribute = (element, attribute, value) => {
    if (typeof value === 'string' && value && element.getAttribute(attribute) !== value) {
      element.setAttribute(attribute, value);
    }
  };
  const setCopy = (element, key, allowSplitLabel = false) => {
    if (!element || !copy[key] || !known(key, element.textContent)) return;
    const textNodes = [];
    const collect = (node) => {
      if (node.nodeType === 3 && normalise(node.nodeValue)) textNodes.push(node);
      if (node.nodeType !== 1 || /^(SVG|IFRAME)$/i.test(node.tagName)) return;
      Array.from(node.childNodes).forEach(collect);
    };
    collect(element);
    if ((textNodes.length === 1 || (allowSplitLabel && textNodes.length > 1)) && normalise(element.textContent) !== normalise(copy[key])) {
      const original = textNodes[0].nodeValue;
      textNodes[0].nodeValue = original.replace(original.trim(), () => copy[key]);
      if (allowSplitLabel) textNodes.slice(1).forEach((node) => { node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), ''); });
    }
  };
  const localiseSearchLink = (link) => {
    let destination;
    let root;
    try {
      destination = new URL(link.getAttribute('href'), window.location.href);
      root = new URL(config.root, window.location.origin);
    } catch {
      return;
    }
    if (destination.origin !== window.location.origin || root.origin !== window.location.origin || destination.username || destination.password) return;
    if (!/^\/(?:(?:bg|en|de|fr|it|es)(?:-[a-z0-9]+)?\/)?search\/?$/i.test(destination.pathname)) return;
    if (!/^\/(?:(?:bg|en|de|fr|it|es)(?:-[a-z0-9]+)?\/?)?$/i.test(root.pathname)) return;
    const path = `${root.pathname.replace(/\/$/, '')}/search`;
    if (destination.pathname !== path) {
      destination.pathname = path;
      setAttribute(link, 'href', destination.href);
    }
  };

  let overlay = null;
  let pending = false;
  const observerOptions = {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['placeholder', 'aria-label', 'href', 'disabled', 'aria-busy']
  };
  const apply = () => {
    pending = false;
    if (!overlay || !overlay.isConnected) return;
    overlayObserver.disconnect();
    try {
      overlay.querySelectorAll('input.zipchat-search-input, input.zipchat-search-modal-input').forEach((input) => {
        setAttribute(input, 'placeholder', copy.placeholder);
        setAttribute(input, 'aria-label', copy.search_label);
      });
      overlay.querySelectorAll('.zipchat-search-submit').forEach((button) => setAttribute(button, 'aria-label', copy.submit_label));
      overlay.querySelectorAll('.zipchat-search-close').forEach((button) => setAttribute(button, 'aria-label', copy.close_label));
      overlay.querySelectorAll('.zipchat-search-product-grid, .zipchat-search-page').forEach((results) => {
        const key = results.classList.contains('zipchat-search-product-grid') ? 'products' : 'pages';
        setCopy(results.previousElementSibling, key);
      });
      overlay.querySelectorAll('.zipchat-search-ai-preview-more').forEach((button) => {
        setCopy(button, 'show_more');
        setAttribute(button, 'aria-label', copy.show_more);
      });
      overlay.querySelectorAll('.zipchat-search-empty > div').forEach((message) => setCopy(message, 'no_results'));
      overlay.querySelectorAll('a.zipchat-search-see-all').forEach((link) => {
        setCopy(link, 'see_all');
        localiseSearchLink(link);
      });
      overlay.querySelectorAll('button.zipchat-search-atc-icon').forEach((button) => {
        const label = button.getAttribute('aria-label');
        const key = ['cart_added', 'cart_out_of_stock', 'cart_learn_more', 'cart_add'].find((state) => known(state, label));
        if (key) setAttribute(button, 'aria-label', copy[key]);
      });
      overlay.querySelectorAll('.zipchat-search-atc[role="dialog"]').forEach((dialog) => {
        dialog.querySelectorAll('.zipchat-atc-back').forEach((button) => setAttribute(button, 'aria-label', copy.back_label));
        dialog.querySelectorAll('.zipchat-atc-close').forEach((button) => setAttribute(button, 'aria-label', copy.dialog_close_label));
        dialog.querySelectorAll('.zipchat-atc-learn-more').forEach((link) => setCopy(link, 'cart_learn_more'));
        dialog.querySelectorAll('.zipchat-atc-add').forEach((button) => {
          if (button.getAttribute('aria-busy') === 'true') return;
          const states = ['cart_added', 'cart_out_of_stock', 'cart_learn_more', 'cart_add'];
          const textState = states.find((state) => known(state, button.textContent));
          if (!textState) return;
          setCopy(button, textState, true);
          const ariaState = states.find((state) => known(state, button.getAttribute('aria-label')));
          if (ariaState) setAttribute(button, 'aria-label', copy[ariaState]);
        });
      });
      setAttribute(overlay, 'lang', locale);
    } finally {
      if (overlay && overlay.isConnected) overlayObserver.observe(overlay, observerOptions);
    }
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(apply);
  };
  const overlayObserver = new MutationObserver(schedule);
  const attach = (root) => {
    if (!root || root === overlay || root.id !== 'zipchat-search-overlay') return;
    overlayObserver.disconnect();
    overlay = root;
    apply();
  };
  const hostId = 'zipchat-shadow-host';
  const overlayId = 'zipchat-search-overlay';
  let host = null;
  let shadowRoot = null;
  let hostFramePending = false;
  const clearOverlay = () => {
    overlayObserver.disconnect();
    overlay = null;
  };
  const refreshRoots = () => {
    const nextHost = document.getElementById(hostId);
    if (nextHost !== host) {
      const previousRoot = shadowRoot;
      shadowLifecycleObserver.disconnect();
      host = nextHost;
      shadowRoot = null;
      if (overlay && overlay.getRootNode() === previousRoot) clearOverlay();
    }
    if (overlay && !overlay.isConnected) clearOverlay();
    if (host && host.isConnected && host.shadowRoot && host.shadowRoot.mode === 'open') {
      if (shadowRoot !== host.shadowRoot) {
        shadowLifecycleObserver.disconnect();
        shadowRoot = host.shadowRoot;
        shadowLifecycleObserver.observe(shadowRoot, { childList: true, subtree: true });
      }
      const shadowOverlay = shadowRoot.querySelector(`#${overlayId}`);
      if (shadowOverlay) attach(shadowOverlay);
      else if (overlay && overlay.getRootNode() === shadowRoot) clearOverlay();
    }
    if (!overlay) attach(document.getElementById(overlayId));
    return !!shadowRoot;
  };
  const refreshWithFrame = () => {
    if (refreshRoots() || !host || hostFramePending) return;
    hostFramePending = true;
    window.requestAnimationFrame(() => {
      hostFramePending = false;
      refreshRoots();
    });
  };
  const shadowLifecycleObserver = new MutationObserver(refreshRoots);
  const lifecycleObserver = new MutationObserver((records) => {
    const disconnected = (host && !host.isConnected) || (overlay && !overlay.isConnected);
    const relevant = records.some((record) => Array.from(record.addedNodes).some((node) => {
      if (node.nodeType !== 1 || (overlay && overlay.contains(node))) return false;
      return node.id === hostId || node.id === overlayId || node.querySelector(`#${hostId}, #${overlayId}`);
    }));
    if (disconnected || relevant) refreshWithFrame();
  });
  const onSearchInteraction = (event) => {
    const target = event.target;
    if (!target || target.nodeType !== 1) return;
    if (target.id === hostId || target.closest('#SearchOpen, #search-in-modal-desktop, #search-in-modal-mobile, .header-search .btn-search, .zipchat-search-input, .zipchat-search-modal-input')) refreshWithFrame();
  };
  const start = () => {
    refreshWithFrame();
    if (document.body) lifecycleObserver.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('focusin', onSearchInteraction, true);
    document.addEventListener('pointerdown', onSearchInteraction, true);
    if (document.readyState !== 'complete') window.addEventListener('load', refreshWithFrame, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
